import { c as _c } from "react/compiler-runtime";
import { IcoEye16 } from '@onefootprint/icons';
const WatchlistCheckEventIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IcoEye16 />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default WatchlistCheckEventIcon;